export const attributes = {
    time_range_error_message: "End time must be after the start time",
} as const;
